import { defineStore } from "pinia"

import actions from './actions';
function initState() {
    return {
        testimonials: [],
        agent: {},
        agentid: -1,
        displayMoreLink: ''
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    actions
});
